/* istanbul ignore file */
import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';

export const StyledCalendarWrapper = styled(Flex)`
  flex-direction: column;
  padding: 1rem;
  width: 55rem;

  * {
    -webkit-transition: none !important;
    transition: none !important;
    -webkit-animation: none !important;
    animation: none !important;
  }

  // & [class^='CalendarMonth_caption_'] {
  //   padding-bottom: 42px !important;
  // }

  // & [class^='CalendarMonth_table_'] {
  //   ${({ readOnly }) => (readOnly ? `pointer-events: none;` : '')}
  // }

  // & [class^='DateInput_fang_'] {
  //   display: none !important;
  // }

  // & [class^='DayPicker_'] {
  //   box-shadow: unset !important;
  // }

  // & [class^='DateRangePicker_picker_'] {
  //   top: 0 !important;
  // }

  > div > div > div > div > div > div > svg {
    display: none !important;
  }

  > div > div > div > div > div > div:nth-child(2) {
    top: 0 !important;
  }

  > div > div > div > div > div > div:nth-child(2) > div {
    box-shadow: unset !important;
  }

  > div
    > div
    > div
    > div
    > div
    > div:nth-child(2)
    > div
    > div
    > div
    > div:nth-child(2)
    > div:nth-child(2)
    > div
    > div
    > div
    > div {
    padding-bottom: 42px !important;
  }

  > div
    > div
    > div
    > div
    > div
    > div:nth-child(2)
    > div
    > div
    > div
    > div:nth-child(2)
    > div:nth-child(2)
    > div
    > div
    > div
    > table {
    ${({ readOnly }) => (readOnly ? `pointer-events: none; ` : '')}
  }
`;
